import positionsOptionsUrl from './positionsOptions.html';
export default {
  templateUrl: positionsOptionsUrl,
  controllerAs: 'ctrl',
  controller: class {
    filterExplicitlySelected = (item) =>
      this.filter.positionIds &&
      this.filter.positionIds.length &&
      this.filter.positionIds.includes(item.id);

    filterNotExplicitlySelected = (item) =>
      !this.filter.positionIds ||
      !this.filter.positionIds.length ||
      !this.filter.positionIds.includes(item.id);

    // Case agnostic search that returns true if search term is contained anywhere in the position name
    filterMatchingSearch = (item) =>
      !this.dropdownFilterCtrl.search ||
      item.name.toUpperCase().includes(this.dropdownFilterCtrl.search.toUpperCase());
  },
  bindings: {
    toggleFilter: '&',
    positions: '=',
    filter: '=',
  },
  require: {
    dropdownFilterCtrl: '^?dropdownFilter',
  },
};
